import CrudTable from "../../../crud/CrudTable"
import {paymenttypeService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Payment() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/paymenttype/edit/"}
          urlnew={"/paymenttype/new/"}
          filter={initFilter}
          i18n={"payment"}
          fieldstable={["code","name","days","remesa"]}
          estructureForm={createEstructureFilter} />
  );
}
